import {
  SkeletonBar,
} from "../loading/LoadingIndicators";

export function QuestionnaireFormSkeleton() {
  const sidebarSkeletonCount = 5;
  const optionSkeletonCount = 3;

  return (
    <div className="flex h-full min-h-0 animate-pulse gap-6">
      <aside className="hidden w-72 flex-shrink-0 border-r border-guardian-20 pr-4 lg:block">
        <SkeletonBar className="mb-4 h-4 w-24" tone="emphasis" />
        <div className="space-y-2">
          {Array.from({ length: sidebarSkeletonCount }, (_, idx) => (
            <div
              key={idx}
              className="w-full rounded-xl border border-guardian-20 bg-white px-3 py-2"
            >
              <div className="flex items-center justify-between gap-2">
                <SkeletonBar className="h-3.5 w-24" tone="emphasis" />
                <SkeletonBar className="h-2.5 w-2.5 rounded-full" tone="emphasis" />
              </div>
              <SkeletonBar className="mt-2 h-3 w-20" tone="subtle" />
            </div>
          ))}
        </div>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <div className="mb-3 flex items-center justify-between">
          <SkeletonBar className="h-4 w-16" tone="emphasis" />
          <SkeletonBar className="h-8 w-28 rounded-lg" tone="emphasis" />
        </div>

        <div className="rounded-xl border border-guardian-20 p-5">
          <SkeletonBar className="mb-4 h-3 w-24" tone="subtle" />
          <SkeletonBar className="mb-3 h-5 w-3/4" tone="emphasis" />
          <SkeletonBar className="mb-6 h-4 w-1/2" tone="subtle" />
          <div className="space-y-3">
            {Array.from({ length: optionSkeletonCount }, (_, idx) => (
              <SkeletonBar key={idx} className="h-10 w-full rounded-full" tone="subtle" />
            ))}
          </div>
        </div>

        <div className="mt-4 border-t border-guardian-20 pt-4">
          <div className="flex items-center justify-between gap-4 p-1">
            <div>
              <SkeletonBar className="mb-2 h-3 w-10" tone="subtle" />
              <SkeletonBar className="h-1 w-28 rounded-full" tone="subtle" />
            </div>
            <SkeletonBar className="h-9 w-[150px] rounded-lg" tone="emphasis" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function QuestionCardSkeleton() {
  const optionSkeletonCount = 3;

  return (
    <div className="relative z-20 animate-pulse rounded-xl border border-guardian-20 p-5">
      <SkeletonBar className="mb-4 h-3 w-24" tone="subtle" />
      <SkeletonBar className="mb-3 h-5 w-3/4" tone="emphasis" />
      <SkeletonBar className="mb-6 h-4 w-1/2" tone="subtle" />
      <div className="space-y-3">
        {Array.from({ length: optionSkeletonCount }, (_, idx) => (
          <SkeletonBar key={idx} className="h-10 w-full rounded-full" tone="subtle" />
        ))}
      </div>
    </div>
  );
}
